<template>
  <section
    v-if="pressKitData"
    :class="$style.root"
  >
    <div
      v-if="pressKitData?.data?.length"
      :class="$style.pressKits"
      ref="pressKit"
    >
      <pagesPressQueryKitEntriesListComponent
        :data="pressKitData?.data"
      />

      <pagesPressQueryKitEntriesListPaginationComponent
        :pagination="pressKitData?.meta?.pagination"
        @setPage="pressKitPage = $event"
      />
    </div>

    <div
      v-if="pressData?.data?.length"
      :class="$style.pressEntries"
      ref="pressEntries"
    >
      <pagesPressQueryEntriesListComponent
        :data="pressData?.data"
        :class="$style.pressKits"
      />

      <pagesPressQueryKitEntriesListPaginationComponent
        :pagination="pressData?.meta?.pagination"
        @setPage="pressPage = $event"
      />
    </div>
  </section>

  <SharedErrorComponent v-else-if="pressKitError || pressError" :error="pressKitError" />
</template>

<script setup>
import { omit } from 'lodash-es'
const route = useRoute()
const router = useRouter()
const pressKit = ref(null)
const pressEntries = ref(null)

// FIXME temp fix
const i18nIso = 'nl-NL' //baseI18nGetDefaultIso()

const pressKitPage = ref(route?.query?.pressKitPage || 1)
const { data: pressKitData, error: pressKitError } = await useAsyncData(() =>
  fetchQueryPath( queryPressKitEntriesThumbnail({ page: pressKitPage.value, locale: i18nIso }) ), { watch: [ pressKitPage ] }
)

const pressPage = ref(route?.query?.pressPage || 1)
const { data: pressData, error: pressError } = await useAsyncData(() =>
  fetchQueryPath( queryPressEntriesThumbnail({ page: pressPage.value, locale: i18nIso }) ), { watch: [ pressPage ] }
)

watch(pressKitPage, (val) => {
  const isOne = val === 1
  // NOTE this watcher previously set `pressPage`, which paginated the wrong
  // list — the pressKit pager could never move past page 1.
  const queryObject = isOne ? omit(filterRouteQuery(route.query), 'pressKitPage') : { ...filterRouteQuery(route.query), pressKitPage: val }
  router.push({ query: queryObject })
})

watch(pressPage, (val) => {
  const isOne = val === 1
  const queryObject = isOne ? omit(filterRouteQuery(route.query), 'pressPage') : { ...filterRouteQuery(route.query), pressPage: val }
  router.push({ query: queryObject })
})

watch(pressKitPage, () => {
  scrollIntoViewWithOffset(pressKit.value)
})

watch(pressPage, () => {
  scrollIntoViewWithOffset(pressEntries.value)
})

</script>

<style module>
.root {
}

.root:has(.pressEntries) .pressKits {
  margin-bottom: calc(var(--unit--vertical) * 2);
}
</style>
